export default {
  facilities: 'Facilities',
  facilitiesType: 'Facilities type',
  transactions: 'Transactions',
  depositNumber: 'Deposit number',
  installmentsCount: 'Installments count',
  pay: 'Pay',
  clearing: 'Clearing',
  successfullyPaid: 'successfully paid',
  successfullyCleared: 'Successfully cleared',
  withdrawalBalance: 'Withdrawal balance',
  pleaseSelectTheDestinationBank: 'Please select the destination bank',
  withdraw: 'Withdraw',
  deposit: 'Deposit'
}
